import AuthLayout from "../../components/layout/AuthLayout";
import RegisterBox from "../../components/registerBox/RegisterBox";
import { useEffect, useState } from "react";
import { OTPPage, PhoneNumberPage } from "../../router/path-route/PathRoute";
import { CheckLogin } from "../../auth/Index";

export default function SendIdentityCode() {
  const [bgButton, setBgButton] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [err, setErr] = useState(true);
  const [nextPage, setNextPage] = useState("");

  useEffect(() => {
    if (inputValue.length === 10 || inputValue.length === 11) {
      const data = {
        identityCode: inputValue,
        nationality: "IR",
      };
      CheckLogin(data)
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("identityCode", inputValue);
            localStorage.setItem("message", res.data.message);
            localStorage.setItem("mobile", "");
            setErr(true);
            setBgButton(true);
            setNextPage(OTPPage);
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            localStorage.setItem("identityCode", inputValue);
            localStorage.setItem("message", err.response.data.message);
            setNextPage(PhoneNumberPage);
            setErr(true);
            setBgButton(true);
          } else if (err.response.status === 500) {
            localStorage.setItem("message", err.response.data.message);
            setErrorMessage(err.response.data.message);
            setErr(false);
          } else if (err.response.status === 406) {
            localStorage.setItem("message", err.response.data.message);
            setErrorMessage(err.response.data.message);
            setErr(false);
          } else if (err.response.status === 405) {
            localStorage.setItem("message", err.response.data.message);
            setErr(true);
            setBgButton(true);
            setNextPage(OTPPage);
          }
        });

      localStorage.setItem("IdentityCode", inputValue);
    } else {
      setBgButton(false);
    }
  }, [inputValue]);

  useEffect(() => {
    if (inputValue === "") {
      setErr(true);
    }
  }, [inputValue.length, inputValue]);

  return (
    <AuthLayout previousPage="/">
      <RegisterBox
        bgButton={bgButton}
        setInputValue={setInputValue}
        inputValue={inputValue.slice(0, 10)}
        placeholder="کد ملی راننده"
        btnTitle="مرحله بعدی"
        nextPage={nextPage}
        title="کد ملی خود را وارد نمایید."
        errorMessage={errorMessage}
        err={err}
        maxLength={10}
      />
    </AuthLayout>
  );
}
